import React from 'react';
import PropTypes from 'prop-types';

// Same label as the Pager count, for totals the API capped (CRTB-2767): "1-50 of 10,000+".
const CappedCount = (props) => {
  const {
    currentPage,
    per,
    totalCount,
  } = props;

  if (!currentPage || !per || !totalCount) {
    return null;
  }

  const start = ((currentPage - 1) * per) + 1;
  const end = Math.min(currentPage * per, totalCount);

  return (
    <span className="text-sm text-brand-blue font-proxima font-normal">
      {`${start}-${end} of ${totalCount.toLocaleString('en-US')}+`}
    </span>
  );
};

export default CappedCount;

CappedCount.propTypes = {
  currentPage: PropTypes.number.isRequired,
  per: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
};
